import React, { Component } from "react";
import cloneDeep from "lodash/cloneDeep";
import Modal from "@cloudscape-design/components/modal";
import Input from "@cloudscape-design/components/input";
import Button from "@cloudscape-design/components/button";
import Box from "@cloudscape-design/components/box";
import Select from "@cloudscape-design/components/select";
import SpaceBetween from "@cloudscape-design/components/space-between";
import DateRangePicker from "@cloudscape-design/components/date-range-picker";
import FormField from "@cloudscape-design/components/form-field";
import Container from "@cloudscape-design/components/container";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { promotionEditModalStore } from "../stores/promotionEditModal";

class PromotionEditModal extends Component {
	constructor(props) {
		super(props);
	}


	editPromotion = async() => {
		try {
			const { promotionEditModal, setPromotionEditModal, Interface } = this.props;


			const body = {
				...promotionEditModal,
				type: promotionEditModal.typePromo,
				start: promotionEditModal.startDate,
				end: promotionEditModal.endDate,
			};

			try {
				const result = await Interface.request("set", {
					class: "data",
					module: "promotion",
					method: "edit"
				}, body);

				Interface.addNoty("Success", "Promotion was successfully edit");
				Interface.loadPromotion();
				setPromotionEditModal({ ...promotionEditModal, show: false });
			} catch (error) {
				Interface.addNoty("Error", error.text || error.toString());
			}
		} catch (error) {
			console.log("ERROR PROMO", error);
		}
	}


	updateParam = (key, value) => {
		const { promotionEditModal, setPromotionEditModal } = this.props;
		const updatedState = cloneDeep(promotionEditModal);
		updatedState[key] = value;
		setPromotionEditModal(updatedState);
	};



	render() {
		const { promotionEditModal, setPromotionEditModal } = this.props;

		return (
			<Modal
				visible={promotionEditModal.show}
				size="medium"
				onDismiss={() => setPromotionEditModal({ ...promotionEditModal, show: false })}
				header={`Edit promotion`}
				children={
					<SpaceBetween direction="vertical" size="l">
						<Container>
							<SpaceBetween direction="vertical" size="m">
								<FormField
									label="Type"
									description="Promotion type"
									stretch
								>
									<Select
										selectedOption={{
											value: promotionEditModal.typePromo,
											label: promotionEditModal.typePromo
										}}
										onChange={({ detail }) =>
											this.updateParam("typePromo", detail.selectedOption.value)
										}
										options={promotionEditModal.currentOption.type}
									/>
								</FormField>

								<FormField
									label="From amount Required"
									description="From amount"
									stretch
								>
									<Input
										type="number"
										value={promotionEditModal.fromAmount}
										onChange={({ detail }) =>
											this.updateParam(
												"fromAmount",
												detail.value === ""
													? ""
													: detail.value
											)
										}
										placeholder="1"
										inputMode="numeric"
									/>
								</FormField>

								<FormField
									label="To amount Required"
									description="To amount (inf-0)"
									stretch
								>
									<Input
										type="number"
										value={promotionEditModal.toAmount}
										onChange={({ detail }) =>
											this.updateParam(
												"toAmount",
												detail.value === ""
													? ""
													: detail.value
											)
										}
										placeholder="1"
										inputMode="numeric"
									/>
								</FormField>

								<FormField
									label="Precent Required"
									description="Precent"
									stretch
								>
									<Input
										type="number"
										value={promotionEditModal.percent}
										onChange={({ detail }) =>
											this.updateParam(
												"percent",
												detail.value === ""
													? ""
													: detail.value
											)
										}
										placeholder="1"
										inputMode="numeric"
									/>
								</FormField>
							</SpaceBetween>
						</Container>


						{/* Даты проведения */}
						<Container header={<Box variant="h2">Promotion Dates</Box>}>
							<FormField
								label="Start/end"
								description="Select the start and end dates for the tournament"
								stretch
							>
								<DateRangePicker
									onChange={({ detail }) => {
										setPromotionEditModal({
											...promotionEditModal,
											startDate: detail.value.startDate.split("+")[0],
											endDate: detail.value.endDate.split("+")[0],
											type: detail.value.type,
										});
									}}
									value={{
										startDate: promotionEditModal.startDate,
										endDate: promotionEditModal.endDate,
										type: "absolute",
									}}
									relativeOptions={[]}
									isValidRange={range => {
										if (range.type === "absolute") {
											const [startDateWithoutTime] = range.startDate.split("T");
											const [endDateWithoutTime] = range.endDate.split("T");
											if (!startDateWithoutTime || !endDateWithoutTime) {
												return {
													valid: false,
													errorMessage: "The selected date range is incomplete.",
												};
											}
											if (new Date(range.startDate) - new Date(range.endDate) > 0) {
												return {
													valid: false,
													errorMessage: "Start date must be before end date.",
												};
											}
										}
										return { valid: true };
									}}
									i18nStrings={{
										todayAriaLabel: "Today",
										nextMonthAriaLabel: "Next month",
										previousMonthAriaLabel: "Previous month",
										customRelativeRangeDurationLabel: "Duration",
										customRelativeRangeDurationPlaceholder: "Enter duration",
										customRelativeRangeOptionLabel: "Custom range",
										customRelativeRangeOptionDescription: "Define a custom range",
										customRelativeRangeUnitLabel: "Unit of time",
										formatRelativeRange: ({ startDate, endDate }) => {
											const start = new Date(startDate).toLocaleString("en-GB");
											const end = new Date(endDate).toLocaleString("en-GB");
											return `${start} - ${end}`;
										},
										formatUnit: (unit, amount) => `${unit}${amount > 1 ? "s" : ""}`,
										dateTimeConstraintText: "Date and time must be within range.",
										renderSelectedAbsoluteRangeAriaLive: (startDate, endDate) =>
											`Selected from ${startDate} to ${endDate}`,
										labelRelativeRange: "Relative range",
										labelAbsoluteRange: "Absolute range",
										dateTimePickerAriaLabel: "Date and time picker",
										dateTimePickerLabel: "Date and Time",
										clearButtonAriaLabel: "Clear date range",
										relativeModeTitle: "Relative mode",
										absoluteModeTitle: "Absolute mode",
										cancelButtonLabel: "Cancel",
										applyButtonLabel: "Apply",
									}}
								/>
							</FormField>
						</Container>
					</SpaceBetween>
				}
				footer={
					<Box float="right">
						<SpaceBetween direction="horizontal" size="m">
							<Button
								variant="normal"
								onClick={() =>
									setPromotionEditModal({ ...promotionEditModal, show: false })
								}
							>
								Close
							</Button>
							<Button
								variant="primary"
								onClick={this.editPromotion}
							>
								Save
							</Button>
						</SpaceBetween>
					</Box>
				}
			/>
		);
	}
}

function withRecoil(Component) {
	return function WrappedComponent(props) {
		const promotionEditModal = useRecoilValue(promotionEditModalStore);
		const setPromotionEditModal = useSetRecoilState(promotionEditModalStore);


		return (
			<Component
				{...props}
				setPromotionEditModal={setPromotionEditModal}
				promotionEditModal={promotionEditModal}
			/>
		);
	};
}

export default withRecoil(PromotionEditModal);
